'use strict';

function getBaggageConditionsMap(baggageResults) {
    return Odigeo._.reduce(baggageResults, function(map, baggageResult) {
        map[baggageResult.travellerType.toUpperCase()] = baggageResult.baggageConditions;
        return map;
    }, {});
}

function getCurrencyConfigMap(currenciesConfig) {
    return Odigeo._.reduce(currenciesConfig, function(map, currencyConfig) {
        currencyConfig.currencySign = currencyConfig.currencySymbol;
        currencyConfig.currencyPosition = currencyConfig.currencyInFront ? 'front': 'back';

        map[currencyConfig.currencyCode.toUpperCase()] = currencyConfig;
        return map;
    }, {});
}

function getBySegmentIndex(list, segmentIndex) {
    var result;

    if (Odigeo._.isArray(list) && !Odigeo._.isEmpty(list)) {
        result = Odigeo._.find(list, 'segmentIndex', segmentIndex);
    }

    return result;
}

var phases = {
    LOADING: 'LOADING',
    SHOPPING: 'SHOPPING',
    CHECKOUT: 'CHECKOUT',
    PAYMENT: 'PAYMENT',
    BUYING: 'BUYING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    PAYMENT_FAILURE: 'PAYMENT_FAILURE',
    ONE_CLICK_CHECKOUT_INTERACTION: 'ONE_CLICK_CHECKOUT_INTERACTION',
};

module.exports = Odigeo.Model.extend({
    defaults: {
        phase: phases.LOADING,
        bookingInfo: null,
        ancillaryInfo: null,
        showFlightInfo: false,
        baggageAdded: false,
    },
    phases: phases,
    baggageConditionsMap: null,
    currencyConfigMap: null,
    baggageSelection: null,

    initialize: function() {
        this.set('phase', phases.LOADING);
        this.set('bookingInfo', null);
        this.set('ancillaryInfo', null);
        this.set('showFlightInfo', false);
        this.baggageConditionsMap = null;
        this.currencyConfigMap = null;
    },

    loadInfo: function(bookingInfo, ancillaryInfo, showFlightInfo) {
        this.set('bookingInfo', bookingInfo);
        this.set('flightDetails', bookingInfo);
        this.set('ancillaryInfo', ancillaryInfo);
        this.set('showFlightInfo', showFlightInfo);
    },

    hasInfo: function() {
        return !Odigeo._.isEmpty(this.get('bookingInfo')) && !Odigeo._.isEmpty(this.get('ancillaryInfo'));
    },

    getTravelers: function() {
        return this.get('ancillaryInfo').travellers;
    },

    getTraveler: function(travelerIndex) {
        return Odigeo._.find(this.getTravelers(), 'travellerNumber', travelerIndex);
    },

    getBookingId: function() {
        return this.get('bookingInfo').bookingBasicInfo.id;
    },

    getBuyerEmail: function() {
        return Odigeo._.get(this.get('bookingInfo'), 'buyer.mail');
    },

    getAncillaryOptionsContainer() {
        const ancillaryInfo = this.get('ancillaryInfo');
        return Odigeo._.get(ancillaryInfo, 'ancillaryOptionsContainer');
    },

    getBaggageConditions: function() {
        if (Odigeo._.isNull(this.baggageConditionsMap)) {
            const ancillaryOptionsContainer = this.getAncillaryOptionsContainer();
            const baggageResults = Odigeo._.get(ancillaryOptionsContainer, 'baggageResultsResponse');
            this.baggageConditionsMap = getBaggageConditionsMap(baggageResults);
        }

        return this.baggageConditionsMap;
    },

    getCurrencyConfig: function() {
        if (Odigeo._.isNull(this.currencyConfigMap)) {
            var currenciesConfig = this.get('ancillaryInfo').currencyConfig;
            this.currencyConfigMap = getCurrencyConfigMap(currenciesConfig);
        }

        return this.currencyConfigMap;
    },

    getSegmentBaggageConditions: function(travelerType, segmentIndex) {
        var baggageConditions = this.getBaggageConditions();

        return getBySegmentIndex(baggageConditions[travelerType], segmentIndex);
    },

    getSegmentsInfo: function() {
        return this.get('bookingInfo').itineraryBookings.itinerarySegments;
    },

    getItineraryInfo: function() {
        return this.get('bookingInfo').itineraryBookings.bookingItinerary;
    },

    hasIncludedBags: function(travelerType, segmentIndex) {
        var includedBaggage = this.getIncludedBags(travelerType, segmentIndex);
        return !Odigeo._.isUndefined(includedBaggage.pieces) && includedBaggage.pieces > 0;
    },

    getIncludedBags: function(travelerType, segmentIndex) {
        var baggageConditions = this.getSegmentBaggageConditions(travelerType, segmentIndex);
        var includedBags = {};

        if (!Odigeo._.isUndefined(baggageConditions) && !Odigeo._.isUndefined(baggageConditions.includedBaggage)) {
            includedBags = {
                pieces: baggageConditions.includedBaggage.numPieces,
                kilos: baggageConditions.includedBaggage.numKilos,
            };
        }

        return includedBags;
    },

    getAllIncludedBagsCount: function() {
        var baggageConditions = this.getBaggageConditions();
        var totalBagsIncluded = null;

        Odigeo._.keys(baggageConditions).map(function(traveler) {
            var totalIncluded = baggageConditions[traveler].map(function(bags) {
                return bags.includedBaggage.numPieces;
            });
            totalIncluded = Odigeo._.reduce(totalIncluded, function(sum, n) {
                return sum + n;
            }, 0);
            totalBagsIncluded += totalIncluded;
        });

        return totalBagsIncluded;
    },

    hasSelectableBagsForSegment: function(travelerType, segmentIndex) {
        return !Odigeo._.isEmpty(this.getSelectableBagsForSegment(travelerType, segmentIndex));
    },

    getSelectableBagsForSegment: function(travelerType, segmentIndex) {
        var baggageConditions = this.getSegmentBaggageConditions(travelerType, segmentIndex);
        var currencyConfig = this.getCurrencyConfig();
        var includedBags = 0;
        var selectableBags = [];
        var baggageFee = {};

        if (!Odigeo._.isUndefined(baggageConditions) && !Odigeo._.isUndefined(baggageConditions.selectableBaggage)) {
            if (!Odigeo._.isUndefined(baggageConditions.includedBaggage)) {
                includedBags = baggageConditions.includedBaggage.numPieces;
            }

            if (!Odigeo._.isUndefined(baggageConditions.baggageFee)) {
                baggageFee = {
                    amount: baggageConditions.baggageFee.amount,
                    currencyCode: baggageConditions.baggageFee.currencyCode,
                    currencyConfig: currencyConfig[baggageConditions.baggageFee.currencyCode],
                };
            }

            selectableBags = Odigeo._.map(baggageConditions.selectableBaggage, function getSelectableBags(selectableBaggage) {
                return {
                    pieces: selectableBaggage.baggageDescriptor.numPieces - includedBags,
                    kilos: selectableBaggage.baggageDescriptor.numKilos,
                    amount: selectableBaggage.money.amount,
                    currencyCode: selectableBaggage.money.currencyCode,
                    currencyConfig: currencyConfig[selectableBaggage.money.currencyCode],
                    baggageFee: baggageFee,
                };
            });

            selectableBags = Odigeo._.filter(selectableBags, function(selectableBag) {
                return selectableBag.pieces > 0;
            });
        }

        return selectableBags;
    },

    hasPaidBagsForSegment: function(traveler, segmentIndex) {
        var paidBags = getBySegmentIndex(traveler.baggageSelections, segmentIndex);

        return !Odigeo._.isUndefined(paidBags) && paidBags.pieces > 0;
    },

    getPaidBagsForSegment: function(traveler, segmentIndex) {
        var paidBags = getBySegmentIndex(traveler.baggageSelections, segmentIndex);

        return Odigeo._.isUndefined(paidBags) ? {} : Odigeo._.pick(paidBags, 'pieces', 'kilos');
    },

    getSelectableBag: function(travelerType, segmentIndex, bagIndex) {
        var allSelectableBaggage = this.getSelectableBagsForSegment(travelerType, segmentIndex);
        var selectableBaggage = allSelectableBaggage[bagIndex];

        return Odigeo._.isUndefined(selectableBaggage) ? {} : selectableBaggage;
    },

    showFlightInfo: function() {
        return this.get('showFlightInfo');
    },
});
